const TAG_ICONS = {
  "Intelligence Artificielle": { src: "/icons/tag-ia.svg", alt: "IA" },
  Webdesign: { src: "/icons/tag-webdesign.svg", alt: "Webdesign" },
  "Site Internet": { src: "/icons/tag-site.svg", alt: "Site internet" },
  Application: { src: "/icons/tag-application.svg", alt: "Application" },
  Marketing: { src: "/icons/tag-marketing.svg", alt: "Marketing" },
  Outil: { src: "/icons/tag-tools.svg", alt: "Outil" },
  Actualité: { src: "/icons/tag-actualite.svg", alt: "Actualité" },
  Sécurité: { src: "/icons/tag-securite.svg", alt: "Sécurité" },
};
import Dot from "@/components/svg/Dot";


const TagIcon = ({ tag, isGuide = false, color = "bleu", extra = [] }) => {
  const icon = TAG_ICONS[tag] ?? TAG_ICONS.Webdesign;
  const extras = (Array.isArray(extra) ? extra : [extra]).filter(Boolean);

  return (
    <div className="flex items-center gap-2">
      <img src={icon.src} alt={icon.alt} className="size-4 shrink-0" />
      <div className="flex items-baseline gap-2">
        {isGuide && (
          <>
            <span className={`p-sm-n md whitespace-nowrap text-${color}`}>SÉRIE</span>
            <div className="inline-block -translate-y-[2px]">
              <Dot color={color} />
            </div>
          </>
        )}
        <span className={`p-sm-n nm whitespace-nowrap text-${color}`}>{tag}</span>
        {extras.flatMap((item) => [
          <div key={`${item}-dot`} className="inline-block -translate-y-[2px]">
            <Dot color={color} />
          </div>,
          <span key={item} className={`p-sm-n lt whitespace-nowrap text-${color}`}>
            {item}
          </span>,
        ])}
      </div>
    </div>
  );
};

export default TagIcon;
